import { C537 } from '@/features/translations/corporations/C537';
import { CCYZ } from '@/features/translations/corporations/CCYZ';
import { CHAH } from '@/features/translations/corporations/CHAH';
import { CHWZ } from '@/features/translations/corporations/CHWZ';
import { CNCK } from '@/features/translations/corporations/CNCK';
import { CRUK } from '@/features/translations/corporations/CRUK';
import { CZJS } from '@/features/translations/corporations/CZJS';

type CorpTranslationProperty = Record<string, string | Record<string, string>>;
export interface CorpTranslation {
    book_unit?: Record<string, string>;
    contact_card?: Record<string, CorpTranslationProperty>
    cta?: CorpTranslationProperty;
    index?: Record<string, string>;
    rapidstor?: CorpTranslationProperty;
    sizeSlider?: CorpTranslationProperty;
    unit_listing?: Record<string, string>;
    wizard?: {
        back?: string;
        reservation?: string;
        scheduleMoveIn?: string;
        copy?: string;
        selectDate?: string;
        next?: string;
        confirm_booking?: string;
        payViaFinverse?: string;
        termsAndConditionsAgree?: string;
        marketingAgree?: string;
        dateOfBirth?: string;
        otherError?: string;
        autobill?: string;
        autobillDetails?: {
            title?: string;
            directDebit?: string;
            creditCard?: string;
            bsbNumber?: string;
            accountNumber?: string;
            none?: string;
        };
        personal?: string;
        business?: string;
        contactDetails?: {
            title?: string;
            titles?: {
                mr?: string;
                mrs?: string;
                miss?: string;
                ms?: string;
                dr?: string;
            };
            commercial?: string;
            company?: string;
            companyNumber?: string;
        };
        alternateContactDetails?: {
            title?: string;
            subtitle?: string;
        };
        accountDetails?: {
            title?: string;
            copy?: string;
            password?: string;
            confirmPassword?: string;
        };
        reservationWithFee?: {
            orderNumber?: string;
            confirmationText?: string;
        };
        reservationConfirmed?: {
            title?: string;
            subtitle?: string;
            finaliseBooking?: string;
        };
        insuranceCoverage?: {
            title?: string;
            subtitle?: string;
            coverage?: string;
            for_up_to?: string;
            noInsuranceSelected?: string;
            manualEntryLabel?: string;
            disclaimer?: string;
            flatRateInsurance?: string;
            selfInsurance?: string;
            usSupply?: string;
            subTitle?: string;
            proofDisclaimer?: string;
            fileTypePlease?: string;
        };
        addressProof?: {
            title?: string;
            subtitle?: string;
            fileUploadHelpText?: string;
            uploading?: string;
            success?: string;
            error?: string;
        };
        insuranceProof?: {
            title?: string;
            subtitle?: string;
            fileUploadHelpText?: string;
            uploading?: string;
            success?: string;
            error?: string;
        };
        boxShop?: {
            title?: string;
            outOfStock?: string;
            pickUpLocation?: string;
            showAll?: string;
            showLess?: string;
        };
        pricingTable?: {
            title?: string;
            charge?: string;
            amount?: string;
            discount?: string;
            tax?: string;
            total?: string;
        };
        identityVerification?: {
            title?: string;
            driverLicenseDetails?: string;
            uploadDriverLicense?: string;
            fileUploadHelpText?: string;
            idDocumentNumber?: string;
        };
        paymentForm?: {
            title?: string;
            errors?: {
                cardHolderInvalid?: string;
                cardNumberInvalid?: string;
                cardExpiryInvalid?: string;
                cardCsvInvalid?: string;
            };
        };
        bookingConfirmation?: {
            title?: string;
            subtitle?: string;
            referenceCode?: string;
            customerSurvey?: {
                title?: string;
                subtitle?: string;
                submit?: string;
            };
            idVerifyButtonText?: string;
            idVerifyText?: string;
        };
        marketingSurvey?: {
            title?: string;
            subtitle?: string;
            Marketing?: string;
            MktgDistance?: string;
            MktgWhy?: string;
            MktgType?: string;
            MktgWhat?: string;
            MktgReason?: string;
            submit?: string;
            defaultOption?: string;
            questions?: string[];
        }
    }
}

/**
 * Corporation specific translations.
 *
 * @loadbearing
 */
export const CORPORATION_TRANSLATIONS = {
    C537: C537,
    CRUK: CRUK,
    CHAH: CHAH,
    CCYZ: CCYZ,
    CZJS: CZJS,
    CHWZ: CHWZ,
    CNCK: CNCK,
};

export type CorporationCode = keyof typeof CORPORATION_TRANSLATIONS;

export const getCorpTranslations = (corpCode: CorporationCode) => {
    return CORPORATION_TRANSLATIONS[corpCode];
};
